import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import HttpService, { formatMessage } from 'src/core/services/http.service'
import ContentTitle from 'src/core/ui/content-header'
import { container } from '../../../inversify.config'
import { UserProfileItem, UserProfileStore } from 'src/stores/profiles/profile-store'
import { UsersStore, UserSummary } from 'src/stores/users/users-store'
import { Query } from 'src/core/stores/data-store'
import { IdentityProps, withIdentity } from '../../../core/services/authentication'
import EntitySelect from 'src/components/tenantEdit'
import { TableModel, TableView } from 'src/core/ui/collections/table'
import { CompressOutlined, GoldOutlined, UserOutlined } from '@ant-design/icons'
import { clone, formatDate } from 'src/core/utils/object'
import { Card, Col, Row, Tabs } from 'antd'
import { TenantDetailsMembersTab } from '../../admin/tenants/components/members/tenant-details-members-tab'
import { render } from 'react-dom'
import { ProfileTenantMembers } from './components/tenant-members'
import OperationRequestList from './components/operationRequests/operationRequest-list'
import Button from 'antd/es/button'


interface ProfileClientsProps extends WithTranslation, IdentityProps {
}

const ProfileClients: FC<ProfileClientsProps> = (props) => {


  const { t } = props
  const [selectedTenantId, setSelectedTenantId] = useState<string>()
  const inputRef = useRef()
  const userId = props.identity.id
  const [active, setActive] = useState(1)

  useEffect(
    () => {

    }, [inputRef, selectedTenantId]
  )

  const onChange = (value) => {
    if (value) {
      setSelectedTenantId(value.value)
    }
  }

  const loadTenant = (tenantId) => {
    if (tenantId) {
      setSelectedTenantId(tenantId)
    }
  }


  return <div>
    <Row gutter={0}>
      <Col span={6}>
        <ContentTitle type={t('Requests')} title={active == 1 ? t('My Clients') : t("Operation Requests")} />
      </Col>
      <Col span={10}>
        <div style={{ width: "100%", padding: "20px", border: "solid .5px #EFEFEF", borderRadius: "10px", background: "white", display: active == 2 ? "none" : undefined }}>
          <EntitySelect label={t("Select Tenant...")} style={{ width: "100%" }} fromProfile notNulleable onChange={value => onChange(value)} loadTenantId={loadTenant} />
        </div>
      </Col>
      <Col span={8}>
        <Button type={"primary"} onClick={() => setActive(2)} style={{ float: "right", borderRadius: 0, marginTop: 40, marginRight: 40, background: active == 2 ? undefined : "#1890ff" }} icon={<CompressOutlined />}>{t("Access Requests")}</Button>
        <Button type={"primary"} onClick={() => setActive(1)} style={{ float: "right", borderRadius: 0, width:180, marginTop: 40, background: active == 1 ? undefined : "#1890ff" }} icon={<UserOutlined />}>{t("Clients")}</Button>
      </Col>
    </Row>

    {active == 1 && <>

      {selectedTenantId != undefined &&
        <Card>
          <ProfileTenantMembers {...props} entityId={selectedTenantId} />
        </Card>
      }

    </>
    }
    {active == 2 &&
      <>
        <OperationRequestList />
      </>
    }
  </div>
}

export default withIdentity(withTranslation()(ProfileClients)) as any